import { storeGet } from '../tools/storage'
import { Bugsnag } from '../tools/general'
import { store } from '../redux/store'
import loginActions from '../redux/login/loginActions'
import ENV from './../config/env'
import { removeObjectProp } from '../tools/dataParse'

function timeout (ms, promise) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new Error('timeout'))
    }, ms)
    promise.then(resolve, reject)
  })
}

const parseResponse = (res, { url, body }) => {
  if (res && res.status < 400) return res
  const message = 'Something went wrong. Please contact support'
  let error = { message: `${res.message || message}` }

  if (res && res.data && (res.code === 'ERR_USER_EXIST')) {
    error = res
  }
  if (res && (res.code === 'AUTH_FAIL' || res.code === 'FATAL_AUTH' || res.code === 'invalid_token')) {
    store.dispatch(loginActions.logout())
  }
  if (res && res.status === 403) {
    error = { message: res.message === 'user is blocked' ? 'The user is blocked' : 'Wrong email or password.' }
  }

  if (res && res.status === 500) {
    error = { message: 'Something went wrong. Please contact support' }
  }
  Bugsnag.notify(new Error(res?.message || res?.code || message), (event) => {
    event.addMetadata('requestData', { url, body: removeObjectProp('password')(body ? JSON.parse(body) : {}) })
  })
  return Promise.reject(error)
}

export const Fetch = async (method, URL, data, { externalToken = null, apiVersion = 'v1', contentType = 'application/json', externalURL = false, customTimeout = 60000 } = {}) => {
  const user = await storeGet() || {}
  const { auth } = user
  const defaultHeaders = {}
  const BASE_URL = ENV.apiUrl + apiVersion

  defaultHeaders.Authorization = `Bearer ${externalToken || auth?.access_token || null}`
  defaultHeaders['Content-Type'] = contentType
  defaultHeaders.Accept = 'application/json, text/plain, */*'

  const requestInit = {
    method: method,
    headers: new Headers(defaultHeaders)
  }

  if (data) {
    requestInit.body = contentType === 'application/json' ? JSON.stringify(data) : data
  }

  return await timeout(customTimeout, fetch(`${!externalURL ? BASE_URL : ''}${URL}`, requestInit)
    .then(response => response.json())
    .then(json => parseResponse(json, { url: URL, body: requestInit.body })))
    .catch(function (error) {
      return Promise.reject(error)
    })
}
